import { useCallback, useEffect, useState } from 'react';
import { Box, Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag } from '../../../../../components';
import { dropdownFetch, getKeyPathValue, request, toast } from '../../../../../utils';
// import { LisAddTestItemForm } from './LisAddTestItemForm';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { TrayAddDetailsForm } from './TrayAddDetailsForm';

const initialtraytDataObj = {
    data: [],
    loading: false
};
export const TrayAssemble = () => {
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [testList, setTestList] = useState([]);
    const [openAddDetailsDialog, setOpenAddDetailsDialog] = useState(false);
    const [itemnamedropdown, setItemnamedropdown] = useState([]);
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [testDataObj, setTestDataObj] = useState(initialtraytDataObj);
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const [input, setInput] = useState('');
    const [testMasterFilter, setTestMasterFilter] = useState([])


    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                tray_name: Yup.string().required('Test Name  Is Required '),

            })
        ),
        defaultValues: {
            min_charge: 0,
            max_charge: 0
        },
        mode: 'all'
    });
    const { handleSubmit, setValue, reset } = methods;

    useEffect(() => {
        if (selectedRecord) {
            console.log("HELLLO SELECTED ROW", selectedRecord)
            const keyValuePair = getKeyPathValue(selectedRecord, '', ['tray_name', '_id', '__v', 'createdAt', 'status']);
            keyValuePair.forEach(({ key, value }) => setValue(key, value));
            setValue('tray_name', selectedRecord?.tray_name)
            setTestList(selectedRecord.items);
        } else {
            reset();
        }
    }, [selectedRecord, setValue, reset]);

    const getItemDropdown = useCallback(async () => {
        const data = await dropdownFetch('product-master');
        setItemnamedropdown(data);
        console.log(itemnamedropdown, 'Hello Dropcdhch');
    }, []);

    useEffect(() => {

        getItemDropdown();
    }, [getItemDropdown]);

    const formSubmit = async (formValues) => {
        setLoading(true);
        let editFlag = false;
        if (selectedRecord && currentAction === 'edit') {
            editFlag = true;
        }
        const payload = {
            ...formValues,
            items: testList.map((data) => ({
                quantity: data.quantity,
                name: data._id,
            }))
        };
        const response = await request(editFlag ? '/tray-update' : '/tray-create', {
            method: editFlag ? 'PUT' : 'POST',
            params: editFlag ? selectedRecord._id : null,
            body: payload
        });
        if (response?.success) {
            toast(`Successfully ${editFlag ? 'updated' : 'created'} Test Master`, { variant: 'success' });
            setSelectedRecord(response?.data);
            setCurrentAction();
            reset();
            setTestList([]);
        } else {
            toast(`Failed to ${editFlag ? 'update' : 'create'} Tray Master`, {
                variant: 'error'
            });
        }
        setLoading(false);
    };

    const handleDeleteRecord = async () => {
        setLoading(true);
        const response = await request('/tray-delete', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully deleted Test master', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to delete Test master', { variant: 'error' });
        }
        setLoading(false);
    };

    const handleQueryWindow = async () => {
        setOpenQueryDialog(true);
        setTestDataObj({ loading: true });

        const response = await request('/tray-list', { method: 'GET' });
        if (response?.success) {
            // Sort data by createdAt in descending order
            const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setTestDataObj({ loading: false, data: sortedData });
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setTestDataObj({ loading: false });
        }
    };

    const TEST_HEADER = [
        {
            header: 'Item Name',
            accessor: (row) => row?.name?.main?.name || '-', // Safely access the nested 'main.name'
            sx: { textTransform: 'capitalize' }
        },
        {
            header: 'Quantity',
            accessor: (row) => row?.quantity || '-' // Ensure quantity is displayed, fallback to '-'
        }
    ];

    const TABLE_COLUMNS = [
        { header: 'Tray Name ', accessor: 'tray_name' },
        { header: 'Status', accessor: 'status', sx: { textTransform: 'uppercase' } },
        { header: 'Created At', accessor: 'createdAt' }
    ];

    useEffect(() => {
        if (Array.isArray(testDataObj.data)) {
            const filtered = testDataObj.data.filter(item =>
                item.tray_name.toLowerCase().includes(input.toLowerCase())
            );
            setTestMasterFilter({ ...testMasterFilter, data: filtered });
        }
    }, [input, testDataObj]);

    const handleInputChange = (e) => {
        setInput(e.target.value);
    };
    return (
        <>
            <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                                Tray Assemble
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={`${lastPathSegment}Write`}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                        setTestList([])
                                    }}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                    onClick={handleSubmit(formSubmit)}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                    onClick={handleDeleteRecord}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Read`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction)}
                                    onClick={handleQueryWindow}
                                >
                                    Query
                                </CustomButtonn>
                                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                                    Print
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained">Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%', boxShadow: '0px 2px 10px #0099ff' }}>
                            <Grid container spacing={1}>

                                <>
                                    <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                        <Stack spacing={0.5} direction="row" alignItems="center">
                                            <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: "1.4rem" }}>Tray Name</Typography>
                                            <TextField
                                                disabled={!['new', 'edit'].includes(currentAction)}
                                                name="tray_name"
                                                placeholder="Enter Tray  Name"
                                                sx={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "" }}
                                            />
                                        </Stack>
                                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                            <Button
                                                onClick={() => setOpenAddDetailsDialog(true)}
                                                variant="contained"
                                                sx={{ width: '15%', justifyContent: 'space-between' }}
                                                disabled={!['edit', 'new'].includes(currentAction) || loading}
                                            >
                                                Add Items
                                            </Button>
                                            <Table
                                                containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                                data={testList}
                                                columns={TEST_HEADER}
                                                size="medium"
                                                showDeleteAction={true}
                                                onDeleteHandler={(id) => {
                                                    setTestList(testList.filter(({ _id }) => _id !== id));
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                            </Grid>
                        </Box>
                    </FormProvider>
                </Container>
            </Paper>
            <Dialog open={openAddDetailsDialog} onClose={() => setOpenAddDetailsDialog(false)} scroll="body" maxWidth="xl">
                <TrayAddDetailsForm
                    onClose={() => setOpenAddDetailsDialog(false)}
                    onAdd={(data) => {
                        console.log("Current Test List:", testList);
                        const [existingDetail] = testList.filter(({ item }) => item === data.name);
                        if (existingDetail) {
                            toast('Test Item Name already chosen', { variant: 'error' });
                            return;
                        }
                        const selectedItem = itemnamedropdown.find(({ _id }) => _id === data.name);
                        const testItemName = selectedItem?.main?.name;
                        if (!testItemName) {
                            toast('Selected test item not found in the dropdown', { variant: 'error' });
                            return;
                        }
                        setTestList((prev) => [
                            ...prev,
                            { ...data, _id: data?._id || selectedItem?._id, name: testItemName },
                        ]);
                        console.log("Updated Test List:", testList);
                    }}
                    testItemDropdown={itemnamedropdown}
                />

            </Dialog>
            <Dialog
                open={openQueryDialog}
                onClose={() => setOpenQueryDialog(false)}
                PaperProps={{ sx: { width: '80%', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={0}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="grey.300"
                >
                    <Typography variant="h4" fontWeight="bold">
                        Tray Master Query Window
                    </Typography>
                    <IconButton onClick={() => setOpenQueryDialog(false)}>
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <Stack>
                    <MuiTextField
                        sx={{
                            width: '100%',
                            '& .MuiOutlinedInput-root': {
                                padding: '0',
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '8px 1.4rem',
                            },
                        }}
                        label="Search Trays"
                        variant="outlined"
                        value={input}
                        onChange={handleInputChange}
                        InputProps={{
                            style: {
                                fontSize: '12px',
                                fontWeight: 600
                            },
                        }}
                    />
                </Stack>
                <Table
                    sx={{ mt: 0.5 }}
                    columns={TABLE_COLUMNS}
                    data={testMasterFilter.data || []}
                    loading={testDataObj.loading}
                    onRowClick={(row) => {
                        setSelectedRecord(row);
                        setOpenQueryDialog(false);
                    }}
                />
            </Dialog>
        </>
    );
};
